import React, { Fragment } from 'react';
import { translate } from '../../Services/translation';
import { currencyFormat } from '../../Services/formatting';
import { useSelector } from "react-redux";
import ConfiguratorProductPrice from './Configurator/ConfiguratorProductPrice';

const ProductPrice = ({ price, variantCount = 0, isConfiguratorProduct, cssBlock, product }) => {

    const { configurator } = useSelector((state) => state);
    const { preConfiguredArticleNumbers, currentProduct, isLoaded} = configurator;

    const showConfiguratorPrice = () => {

        if(isConfiguratorProduct && !isLoaded)
            return true

        return isConfiguratorProduct && !preConfiguredArticleNumbers.hasOwnProperty(currentProduct.articleNumber) && isLoaded;
    }

    const getLitiumPrice = () => {
        return preConfiguredArticleNumbers.hasOwnProperty(currentProduct.articleNumber) ? preConfiguredArticleNumbers[currentProduct.articleNumber] : price;
    }

    const pricePrefix = (isCampaignActive, isCampaignPrice) => {
        return isCampaignActive
            ? isCampaignPrice
                ? translate(`product.price.now`)
                : translate(`product.price.before`)
            : false

        // if (variantCount > 1) {
        //   return isFrom
        //     ? isCampaign
        //       ? translate(`product.price.now`)
        //       : translate(`product.price.from`)
        //     : translate(`product.price.before`);
        // } else if ((variantCount = 1)) {
        //   return isFrom
        //     ? isCampaign
        //       ? translate(`product.price.now`)
        //       : false
        //     : isCampaign
        //       ? translate(`product.price.before`)
        //       : false;
        // } else {
        //   return false;
        // }
    };

    const setPricePrefix = (isCampaignActive, isCampaignPrice = false) => {
        return (
            pricePrefix(isCampaignActive, isCampaignPrice) && (
                <span className="product__price--label">
                    {pricePrefix(isCampaignActive, isCampaignPrice)}
                </span>
            )
        );
    };

    const getPriceComponent = (price) => {
        if (price.hasCampaignPrice && (!price.hasClubPrice || price.campaignPrice.price < price.clubPrice.price)) {
            return (
                <Fragment>
                    <span className={`product__campaign-price ${cssBlock ? cssBlock + "__campaign-price" : ""}`}>
                        {setPricePrefix(true, true)}
                        {currencyFormat(price.campaignPrice.price)}
                    </span>
                    {price.hasRetailPrice && (
                        <span className={`product__old-price ${cssBlock ? cssBlock + "__old-price" : ""}`}>
                            {setPricePrefix(true, false)}
                            {currencyFormat(price.retailPrice.price)}
                        </span>
                    )}
                </Fragment>
            )
        } else if (price.hasClubPrice) {
            return (
                <Fragment>
                    <span className={`product__club-price ${cssBlock ? cssBlock + "__club-price" : ""}`}>
                        {setPricePrefix(false, false)}
                        {currencyFormat(price.clubPrice.price)}
                        <div className="product__club-price-text">{translate(`product.price.club.member`)}</div>
                    </span>
                    {price.hasRetailPrice && (
                        <span className={`product__old-price ${cssBlock ? cssBlock + "__old-price" : ""}`}>
                            {setPricePrefix(false, false)}
                            {currencyFormat(price.retailPrice.price)}
                            <div className={`product__club-price-text ${cssBlock ? cssBlock + "__club-price-text" : ""}`}>{translate(`product.price.noclub.member`)}</div>
                        </span>
                    )
                    }
                </Fragment >
            )
        } else if (price.hasRetailPrice) {
            return (<Fragment>
                {setPricePrefix(false, false)}
                <span className={`price ${cssBlock ? cssBlock + "__price" : ""}`}>
                    {currencyFormat(price.retailPrice.price)}
                </span>
            </Fragment>
            )
        }
    }

    return (
        <div className={`product-detail__price-info ${cssBlock ? cssBlock + "__price-info" : ""}`}>
            { showConfiguratorPrice()
                ? <ConfiguratorProductPrice cssBlock={cssBlock} />
                : getPriceComponent(getLitiumPrice())
            }
        </div>
    );
};

export default ProductPrice;
